/**
 * @file 反馈页
 * @author FengGuang(fengguang01@baidu.com)
 */

import React from 'react';

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import Banner from '../../components/banner/Banner';
import MainForm from './components/main-form/MainForm';
import useConsultationAndCooperationStore from './consultationAndCooperationHooks';


const ConsultationAndCooperation: React.FC = () => {
    const {
        verifyCodeImg,
        verifyCodeLoading,
        feedbackForm,
        getVerifyCode,
        submit
    } = useConsultationAndCooperationStore();

    return (
        <div className="page paddle-cac-page">
            <Header />
            <Banner
                title="咨询与合作"
                divider
            />
            <div className="paddle-cac-page-container">
                <MainForm
                    verifyCodeImg={verifyCodeImg}
                    verifyCodeLoading={verifyCodeLoading}
                    getVerifyCode={getVerifyCode}
                    form={feedbackForm}
                    onFinished={submit}
                />
            </div>
            <Footer />
        </div>
    );
};

export default ConsultationAndCooperation;
